import { AshaBlockServices } from "./AshaBlocks";
import { AshaServices } from "./AshaService";
export const DashboardService = {
  fetchDashboardData: async (user) => {
    try {
      const roleId = user?.roleDetails?.id;
      let res;
      if (roleId === 1) {
        res = await AshaServices.getDashBoardDataSuperAdmin();
        return res || 0;
      }
      else if (roleId === 2) {
        res = await AshaServices.getDashBoardDataTaluk(user.talukDetails.id, 1, 100);
        return res || 0;
      } else if (roleId === 3) {
        res = await AshaServices.getDashBoardDataPhc(user.phcDetails.id);
        return res || 0;
      } else if (roleId === 4) {
        res = await AshaServices.getDashBoardDataAshaBlock(user.ashaBlockDetails?.id);
        return res || 0;
      } else 
      res = await AshaServices.getDashBoardDataSuperAdmin();
      return res || 0;
      return 0; // fallback if nothing matches
    } catch (error) {
      console.error("DashboardService → fetchAshaCount error:", error);
      return 0;
    }
  }
};
